module.exports = __webpack_public_path__ + "img/ceiling-lamp-sm.e4df59de.svg";